import React, { useState } from "react";
import axios from "axios";
import qs from "qs"; // Tambahkan ini untuk encoding
import { useNavigate } from "react-router-dom"; // Import useNavigate
import "../css/pageLogin.css";
// import LoginCont from "../contents/LoginCont";

const LoginPage = () => {
  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");
  const [message, setMessage] = useState("");
  const navigate = useNavigate(); // Inisialisasi navigate

  const handleLogin = async (e) => {
    e.preventDefault();

    try {
      // Gunakan qs.stringify untuk format x-www-form-urlencoded
      const data = qs.stringify({
        username: username,
        password: password,
      });

      const response = await axios.post("https://monitoringlocal.stii.co.id/ApiAuthController/login", data, {
        headers: {
          "Content-Type": "application/x-www-form-urlencoded",
        },
      });
      // const response = await axios.post("http://localhost/monitoring-local/ApiAuthController/login", data, {
      //   headers: {
      //     "Content-Type": "application/x-www-form-urlencoded",
      //   },
      // });

      if (response.data.status) {
        setMessage("Login berhasil!");
        // Simpan token atau data user ke local storage atau state management (jika menggunakan Redux atau Context)
        // Simpan token atau data user ke local storage
        // localStorage.setItem("userToken", response.data.token); // Jika server memberikan token

        // Pindah ke halaman lain
        navigate("/qrcode"); // Ganti "/dashboard" dengan path halaman yang Anda inginkan
      } else {
        // setMessage(response.data.message);
        setMessage(response.data.message.replace(/<\/?p>/g, ""));
      }
    } catch (error) {
      setMessage("Login gagal. Periksa koneksi Anda.");
    }
  };

  return (
    <>
      <div className="container">
        <div className="row justify-content-center">
          <div className="col-xl-8 col-10">
            <div className="card o-hidden border-0 shadow-lg my-4">
              <div className="card-body p-0">
                <div className="row">
                  <div className="col">
                    <div className="p-5">
                      <div className="col mb-2 text-center">
                        <img src="logo_sti-alpha.png" alt="PT STII" />
                        <div className="h3 font-weight-bold">STI Customer Portal</div>
                      </div>
                      <form className="user" onSubmit={handleLogin}>
                        <div className="form-group">
                          <input type="text" value={username} onChange={(e) => setUsername(e.target.value)} className="form-control form-control-user" placeholder="Username" />
                        </div>
                        <div className="form-group">
                          <input type="password" value={password} onChange={(e) => setPassword(e.target.value)} className="form-control form-control-user" placeholder="Password" />
                        </div>
                        <div className="form-group">{message && <p>{message}</p>}</div>
                        <button type="submit" className="mt-5 btn btn-primary btn-user btn-block">
                          Login
                        </button>
                      </form>
                      <hr />
                      <div className="text-center">
                        <h5 className="mt-3 text-muted">Can't access your account?</h5>
                        <h5 className="text-muted">Contact STI by email :</h5>
                        <h5 className="text-muted">orderprocessing@stimberindo.co.id</h5>

                        {/* <p className="mt-5 mb-1 text-muted">©Sumatera Timber Indo Industry, <?= date("Y"); ?></p> */}
                        {/* <p className="text-muted mb-0">Version 1.8.2</p> */}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default LoginPage;
